export default "__VITE_ASSET__DQYklG0D__"